// extracted by mini-css-extract-plugin
export default {"dropdown":"DropdownAnimation_dropdown__EU6hr","dropButton":"DropdownAnimation_dropButton__JqkQA","dropdownContent":"DropdownAnimation_dropdownContent__-LuFa"};